module.exports = __webpack_public_path__ + "img/React.64963937.png";